import { OdataFilters, queryCollection } from "helpers/reqparams";
import { alertRequest, body, downloadFileHandler, request } from "services/request";

const resource = "api/news";
const newsQuery = {
    orderBy: "id desc",
};

const index = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...newsQuery });
    return request(`${resource}/getlist${query}`, { method: "GET" }, { countInHeaders: true });
};

const getListExcel = ({ preparedFilter, ...params }: OdataFilters) => {
    const query = queryCollection(params, { filter: preparedFilter, ...newsQuery });
    return request(`${resource}/getListExcel?${query}`, { method: "GET" }, { withoutMiddleware: true }).then((res) =>
        downloadFileHandler(res, "Новости.xlsx"),
    );
};

const apply = (params: {}) => alertRequest(`${resource}/apply`, body(params));

const uploadFile = (params: {}) => alertRequest(`${resource}/uploadFile`, params);

const getItem = ({ id }: { id: number }) => request(`${resource}/get?id=${id}`, { method: "GET" });

const delItem = (params: {}) => alertRequest(`${resource}/delete`, body(params));

export { index, apply, getItem, delItem, uploadFile, getListExcel };
